const translationEN = {
  generalData: "General Data",
  name: "Full Name",
  nameParam: "Name",
  date: "Date",
  phoneNumber: "Phone",
  patientGeneralData: "Patient General Data",
  detailData: "Detail Data",
  feetMeasurement: "Feet Measurement",
  overview: "Overview",
  firstNameRequired: "First Name is required",
  firstName: "First Name",
  lastName: "Last Name",
  identityId: "Identity ID",
  emailLabel: "E-mail",
  phoneNumber1: "Phone Number 1",
  phoneNumber2: "Phone Number 2",
  gender: "Gender",
  selectGender: "Please select a gender",
  male: "Male",
  female: "Female",
  dateofBirth: "Date of Birth",
  birthDateRequired: "Birth Date is required",
  height: "Height",
  weight: "Weight",
  shoeSize: "Shoe Size",
  euShoeSize: "Eu Shoe Size",
  rightHanded: "Right handed",
  leftHanded: "Left handed",
  controlExamSchedule: "Control Exam Scheadule",
  ekovelReport: "Ekovel Report",
  generalExamination: "General Examination",
  optimalWeight: "Optimal Weight",
  feetParametes: "Feet Parameters",
  role: "Role",
  displayName: "Display Name",
  userName: "User Name",
  organization: "Organization",
  active: "Active",
  deleteConfirmation: "Delete Confimation",
  areYouSureToDelete: "Are you sure you want to delete user",
  delete: "Delete",
  cancel: "Cancel",
  deactivate: "Deactivate",
  activate: "Activate",
  activateUser: "Activate User",
  deactivateConfirmation: "Confirm Deaktivaction",
  areYouSureDeactivate: "Are you sure you want to deactivate user",
  areYouSureActivate: "Are you sure you want to activate user",
  updateSerialNumber: "Update serial number",
  areYouSureToDeleteUser: "Are you sure you want to delete user",
  actions: "Actions",
  parameter: "Parameter",
  value: "Value",
  ekovelStepCorrectsize: "Ekovel Step Correct size",
  initialHeight: "Initial Height",
  optimalHeight: "Optimal Height",
  firstCheck: "First Check",
  secondCheck: "Second Check",
  thirdCheck: "Third Check",
  therapy: "Therapy",
  leftFoot: "Left Foot",
  rightFoot: "Right Foot",
  serialNumber: "Serial Number",
  footLength: "Foot length (mm)",
  footWidth: "Foot width (mm)",
  left: "Left",
  right: "Right",
  back: "Back",
  finish: "Finish",
  next: "Next",
  selectLeg: "Select leg",
  legLengthDifference: "Leg Length Difference",
  adjustmentInterval: "Adjustment Interval",
  adjustmentPeriod: "Adjustment Period AI",
  week: "Week",
  weeks: "weeks",
  serialNumberDate: "Serial number date",
  checkExaminationSchedule: "Check Examination Schedule",
  escSize: "ESC size",
  saveAndOpenReport: "Save and open report",
  create: "Create",
  noRowsToShowPatients: "There is no data available",
  DepthOfFootArch: "MLA Depth",
  DegreeOfTendon: "Tendon Position",
  LegLengthDifference: "Leg length difference",
  FootprintSplit: "Foot print split",
  FootParamDescription: "Parametri stopala",
  report: "Report",
  examinationDate: "Examination Date",
  leftFootMeasurement: "Left Foot Measurement",
  rightFootMeasurement: "Right Foot Measurement",
  footParametersLeft: "Foot Parameters Left",
  footParametersRight: "Foot Parameters Left",
  optimalMlaDepth: "Optimal MLA Depth",
  optimalMlaHeight: "Optimal MLA Height",
  mlaDescendingLevel: "MLA Descending level",
  mlaDescending: "MLA Descending",
  tendonPosition: "Tendon position",
  legAlignement: "Leg Alignment",
  and: "And",
  selectedLeg: "Selected leg",
  allAdmins: "ALL ADMINS",
  allUsers: "ALL USERS",
  allPatients: "ALL PATIENTS",
  therapyDuration: "Therapy Duration",
  medialArchDisplacement: "MEDIAL ARCH DISPLACEMENT",
  verticalDisplacement: "Vertical displacement",
  horizontalDisplacement: "Horizontal displacement",
  displacementPoourcentage: "Displacement percentage",
  displacementLevel: "Displacement Level",
  medialArchDepth: "Medial arch depth X [mm]",
  medialArchHeight: "Medial arch height Y [mm]",
  tendonBendingDegree: "Bending degree of the tendon",
  medialArchOptimalDepth: "Medial arch optimal depth Xo [mm]",
  medialArchOptimalHeight: "Medial arch optimal height Yo [mm]",
  backToPatientsList: "Back to Form",
  allStepsAreDone: "All steps completed",
  user: "User",
  yes: "Yes",
  no: "No",
  selectAlignment: "Select Alignment",
  createAdmin: "Create Admin",
  createSubAdmin: "Create SubAdmin",
  createUser: "Create User",
  createPatient: "Create Patient",
  editPatient: "Edit Patient",
  serialNumberSucces: "Succesfully updated the serial number",
  noRowsToShow: "No results to show",
  admittedBy: "Admitted by",
  logout: "Logout",
  search: "Search",
  suborganization: "Suborganization",
  town: "Town",
  userSuccess: "Succesfuly created",
  emailAlreadyExist: "Error: Email already exist",
  loginErroMEssage: "Username or password is incorrect.",
  accept: "Agree",

  // Privacy Policy Text
  privacyPolicy: "Privacy Policy",
  lastUpdated: "Last Updated: 03.04.2025",
  privacyPolicyIntro:
    "Welcome to the Ekovel company app. We are committed to protecting your privacy and the security of your personal data. This Privacy Policy explains what data we collect, how we use it, and how we store it.",
  dataCollectionTitle: "1. DATA COLLECTION",
  personalData:
    "Personal data of patients: name, surname, date of birth, contact information.",
  therapyData:
    "Therapy data: medical findings, recommended treatments, data about orthopedic insoles.",
  technicalData:
    "Technical data: device information, IP address, app usage data.",
  dataUsageTitle: "2. DATA USAGE",
  dataUsage1: "Maintaining records of patients and their therapies.",
  dataUsage2: "Creating and customizing orthopedic insoles.",
  dataUsage3: "Improving service quality and app functionality.",
  dataUsage4: "Fulfilling legal and regulatory obligations.",
  dataStorageTitle: "3. DATA STORAGE AND PROTECTION",
  dataProtection:
    "Your data is stored on secure servers with restricted access and is protected by appropriate security measures. Only authorized personnel have access to the data, and it is not shared with third parties without your consent, unless required by law.",
  userRightsTitle: "4. USER RIGHTS",
  userRights1: "Access your data.",
  userRights2: "Request correction of inaccurate data.",
  userRights3: "Request deletion of data when it is no longer needed.",
  userRights4: "Withdraw consent for data processing.",
  contactRights:
    "To exercise your rights, contact us via ekovelcentar@gmail.com",
  privacyPolicyAcceptanceTitle: "5. ACCEPTANCE OF THE PRIVACY POLICY",
  privacyPolicyAcceptance:
    'By using this app, users confirm that they have read, understood, and agree with the Privacy Policy. Upon first launching the app, this Privacy Policy will be displayed, and continued use of the app will be possible only after clicking the "Agree" button.',
  contactTitle: "6. CONTACT",
  contactIntro:
    "If you have any questions regarding this Privacy Policy, you can contact us at:",
  companyName: "EKOVEL CENTAR DOO",
  companyAddress: "Ugrinovački put 104, 11080, Belgrade (Zemun), Serbia",
  companyEmail: "Email: ekovelcentar@gmail.com",
  companyPhone: "Phone: 0113774750",
  policyUpdateNotice:
    "We reserve the right to periodically update this Privacy Policy. You will be notified of any changes in a timely manner via the app.",
};

export { translationEN };
